// extracted by mini-css-extract-plugin
export default {"wrapper":"FormCheckbox-module--wrapper--3xwcW","label":"FormCheckbox-module--label--Z1jGP","label--big":"FormCheckbox-module--label--big--cI1IT"};